



































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import OpportunityStageEnum from '@/models/Opportunities/OpportunityStage';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import OpportunityDescriptionEdit from '@/components/Opportunities/OpportunityDescriptionEdit.vue';
import OpportunityGeneralDetailsEdit from '@/components/Opportunities/OpportunityGeneralDetailsEdit.vue';

@Component({
    name: 'OpportunityDetails',
    components: {
        OpportunityDescriptionEdit,
        OpportunityGeneralDetailsEdit,
    },
})
export default class extends GiganautVue {
    OpportunityStageEnum = OpportunityStageEnum;

    get opportunity() { return OpportunityDetailsModule.opportunity; }

    get hasPerm(): boolean {
        return !!this.opportunity && Array.isArray(this.opportunity.workTypes) && this.opportunity.workTypes.includes('Perm');
    }
    get hasTemp(): boolean {
        return !!this.opportunity && Array.isArray(this.opportunity.workTypes) && this.opportunity.workTypes.includes('Temp');
    }

    get sourceLabel(): string {
        if (!this.opportunity || !this.opportunity.source) return '-';
        return this.opportunity.source.name || '-';
    }

    get valueTypeLabel(): string {
        // Mirrors OPPORTUNITY_VALUE_TYPE_* constants in api/core/opportunities.go.
        if (!this.opportunity) return '-';
        switch (this.opportunity.valueType) {
            case 1: return 'One Off';
            default: return '-';
        }
    }

    get lostReasonLabel(): string {
        if (!this.opportunity || !this.opportunity.lostReason) return '-';
        return this.opportunity.lostReason.name || '-';
    }

    get branchName(): string {
        return this.opportunity && this.opportunity.branch ? this.opportunity.branch.brandName : '';
    }

    get deskName(): string {
        return this.opportunity && this.opportunity.desk ? this.opportunity.desk.name : '';
    }

    formatValue(v: number | null): string {
        // value is stored in pence (v-currency-field is configured globally
        // with valueAsInteger: true, decimalLength: 2 — see main.ts), so
        // divide by 100 to display as pounds.
        if (v == null) return '-';
        return '£' + (v / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    formatDate(s: string | null): string {
        if (!s) return '';
        return new Date(s).toLocaleDateString();
    }
}
